import qs from 'qs';

interface ISearchConfig {
  collectionId: string;
  filterKey: string;
  filterValue: string;
  options: string;
  query: string;
  type: string;
}

const formatSearchConfigOptionsToUrl = (options) => {
  const optionsObj = qs.parse(options);
  const filterString = qs.stringify(optionsObj.filters, { indices: false });

  return optionsObj.filters ? `${filterString}` : '';
};

export const getLinkFromSearchConfig = ({
  collectionId,
  filterKey,
  filterValue,
  options,
  query,
  type,
}: ISearchConfig) => {
  const filterOptions = formatSearchConfigOptionsToUrl(options);

  if (type === 'search') {
    return `/search?query=${query}&pageNumber=1${filterOptions ? `&${filterOptions}` : ''}`;
  }

  if (type === 'collection') {
    return `/collections/${collectionId}${filterOptions ? `?${filterOptions}&pageNumber=1` : '?pageNumber=1'}`;
  }

  if (type === 'brand') {
    return `/brand/${collectionId}${filterOptions ? `?${filterOptions}&pageNumber=1` : '?pageNumber=1'}`;
  }

  if (type === 'browse') {
    return `/search?${filterKey}=${filterValue}${filterOptions ? `&${filterOptions}&pageNumber=1` : '&pageNumber=1'}`;
  }

  if (collectionId === 'gift-cards') {
    return '/gift-cards';
  }

  return '/search?pageNumber=1';
};
